import React, { useEffect, useState } from "react";
import useNear from "../hooks/nearHook";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";

function AccountField({ accountId, setAccountId, label="Account", disabled=false }) {
  const near = useNear();
  return (
    <FormControl variant="outlined" fullWidth disabled={disabled}>
      <InputLabel htmlFor="account-field">{label}</InputLabel>
      <OutlinedInput
        id="account-field"
        value={accountId || ""}
        onChange={(e) => setAccountId(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setAccountId(near.account.account)}
              edge="end"
              disabled={disabled}
            >
              <AccountCircleIcon />
            </IconButton>
          </InputAdornment>
        }
        label="Password"
      />
    </FormControl>
  );
}

export default AccountField;
